import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
} from '@chakra-ui/react';
import { ErrorMessage } from '@hookform/error-message';
import type { SnapSiteConfigEditFormDataUnvalidated } from '@snap-types/models/snap-site-config';
import type { FieldPathFn } from '@ui/components/form';
import { get, useFormContext } from 'react-hook-form';

export function QuantityAwareForm({
  fieldPath,
}: {
  fieldPath: FieldPathFn<SnapSiteConfigEditFormDataUnvalidated>;
}) {
  const form = useFormContext();

  const shiftHoursFieldPath = fieldPath('shiftHours');
  const bufferDaysFieldPath = fieldPath('bufferDays');
  const moveDayRatioFieldPath = fieldPath('moveDayRatio');

  const shiftHoursFieldError = get(form.formState.errors, shiftHoursFieldPath);

  const bufferDaysFieldError = get(form.formState.errors, bufferDaysFieldPath);

  const moveDayRatioFieldError = get(
    form.formState.errors,
    moveDayRatioFieldPath,
  );

  return (
    <Flex gap="2">
      <FormControl isInvalid={!!shiftHoursFieldError} isRequired>
        <FormLabel htmlFor={shiftHoursFieldPath}>Shift Hours:</FormLabel>

        <Input
          {...form.register(shiftHoursFieldPath)}
          id={shiftHoursFieldPath}
          type="number"
          inputMode="numeric"
          min={1}
        />

        <ErrorMessage
          name={shiftHoursFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl isInvalid={!!bufferDaysFieldError} isRequired>
        <FormLabel htmlFor={bufferDaysFieldPath}>Buffer Days:</FormLabel>

        <Input
          {...form.register(bufferDaysFieldPath)}
          id={bufferDaysFieldPath}
          type="number"
          inputMode="numeric"
          min={0}
        />

        <ErrorMessage
          name={bufferDaysFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>

      <FormControl isInvalid={!!moveDayRatioFieldError} isRequired>
        <FormLabel htmlFor={moveDayRatioFieldPath}>
          Move Days Per Operation:
        </FormLabel>

        <Input
          {...form.register(moveDayRatioFieldPath)}
          id={moveDayRatioFieldPath}
          type="number"
          inputMode="decimal"
          min={0.01}
          step={0.01}
        />

        <ErrorMessage
          name={moveDayRatioFieldPath}
          render={({ message }) => (
            <FormErrorMessage>{message}</FormErrorMessage>
          )}
        />
      </FormControl>
    </Flex>
  );
}
